import { render, staticRenderFns } from "./PrizeSlackers.vue?vue&type=template&id=22b43476&scoped=true"
import script from "./PrizeSlackers.vue?vue&type=script&lang=js"
export * from "./PrizeSlackers.vue?vue&type=script&lang=js"
import style0 from "./PrizeSlackers.vue?vue&type=style&index=0&id=22b43476&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b43476",
  null
  
)

export default component.exports